import type { ImportExportEntity } from '../apiService/importExportApiService';

/**
 * Display label for an entity key: `dealer_values` → `Dealer Values`.
 */
export function formatEntityName(entityName: string): string {
  return String(entityName || '')
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

/** Sort entities A–Z by the same label shown in Import/Export dropdowns. */
export function sortImportExportEntitiesByLabel(
  entities: ImportExportEntity[],
): ImportExportEntity[] {
  return [...entities].sort((a, b) =>
    formatEntityName(a.entity).localeCompare(formatEntityName(b.entity), undefined, {
      sensitivity: 'base',
    }),
  );
}

/** Sort select enum options A–Z by visible label. */
export function sortSelectOptionsByLabel<
  T extends string | number | { label?: string; value?: string | number },
>(options: T[]): T[] {
  const optionLabel = (option: T): string => {
    if (typeof option === 'object' && option !== null) {
      const obj = option as { label?: string; value?: string | number };
      return String(obj.label ?? obj.value ?? '');
    }
    return String(option);
  };

  return [...options].sort((a, b) =>
    optionLabel(a).localeCompare(optionLabel(b), undefined, {
      sensitivity: 'base',
    }),
  );
}
